import { styled } from '@mui/system';
import {
  Button as MUIButton,
  IconButton as MUIIconButton,
} from '@mui/material';

interface StyledButtonProps {
  width?: string;
  height?: string;
  color?: string;
}

const StyledButton = styled(MUIButton)<StyledButtonProps>(
  ({ width = '100%', height = '40px' }) => ({
    justifyContent: 'center',
    width: width,
    height: height,
    fontSize: '14px',
    borderRadius: '100px',
    textTransform: 'none',
  })
);

const StyledIconButton = styled(MUIIconButton)<StyledButtonProps>(
  ({ width = '40px', height = '40px', color }) => ({
    width: width,
    height: height,
    color: color,
    backgroundColor: 'transparent',
    paddingRight: 2,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:active': {
      backgroundColor: 'transparent',
    },
    '&:focus': {
      backgroundColor: 'transparent',
    },
    '&:disabled': {
      backgroundColor: 'transparent',
    },
  })
);

export { StyledButton, StyledIconButton };
